import { useEffect, useRef, useState } from 'react';
import { useParams, useRouteMatch } from 'react-router-dom';
import { soundEnvironment } from '../../environments/sound';
import useFontSizeStore from '../../store/useFontSize';
import useSound from '../useSound';

function useBackgroundMusic() {
  const currentPlaying = useRef(1);

  const isLoginOrRegister = !!useRouteMatch(['/login', '/register']);

  const [playBackground01, { isPlaying: isPlaying01, stop: stop01 }] = useSound(soundEnvironment.backgroundLoop[0], { interrupt: false, volume: 0.3 });
  const [playBackground02, { isPlaying: isPlaying02, stop: stop02 }] = useSound(soundEnvironment.backgroundLoop[1], { interrupt: false, volume: 0.3 });

  useEffect(() => {
    if (isLoginOrRegister) {
      stop01();
      stop02();

      return;
    }

    if (isPlaying01)
      return;

    if (isPlaying02)
      return;

    if (currentPlaying.current === 1) {
      currentPlaying.current = 2;

      stop01();
      playBackground02();
    } else {
      currentPlaying.current = 1;

      stop02();
      playBackground01();
    }
  }, [isLoginOrRegister, playBackground01, playBackground02, isPlaying01, isPlaying02, stop01, stop02]);
}

export default function useAppEffects(): void {
  // Background Music
  useBackgroundMusic();

  const [html] = useState(() => document.querySelector('html'));
  const fontSize = useFontSizeStore(state => state.fontSize);

  useEffect(() => {
    html.style.fontSize = `${fontSize}px`;
  }, [fontSize, html]);
}
